module.exports = __webpack_public_path__ + "3a22d696.svg";